import { Valueof } from '@app/utils/types';

export const OrderDir = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type OrderDirType = Valueof<typeof OrderDir>;
